import styled from 'styled-components';

export const ShortTextarea = styled.textarea`
    border: ${props => props.theme.inputBorders};
    border-radius: ${props => props.theme.textareaBorderRadius};
    font-size: ${props => props.theme.fontSizePrimary};
    ${props => (props.isInvalid ? `border-color: ${props.theme.invalidColor}` : '')};
    display: block;
    overflow: hidden;
    resize: vertical;
    line-height: 20px;
    padding: 11px 0px 11px 8px;
    min-height: 20px;
    font-family: Arial, sans-serif;
    padding-bottom: 20px;
    padding-right: 4px;
`;
